export default {
  "content": "<path d=\"M11 20.5H3v-2h8v2zM21 20.5h-8v-2h8v2zM11 15.5H3v-2h8v2zM21 15.5h-8v-2h8v2zM11 10.5H3v-2h8v2zM21 10.5h-8v-2h8v2zM11 5.5H3v-2h8v2zM21 5.5h-8v-2h8v2z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};